import * as React from 'react';
import styled from 'styled-components';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';

const StyledTextField = styled(MuiTextField)`
    & label {
        margin-bottom: 0px;
    }
`;

export type DSTextFieldProps = MuiTextFieldProps & { ['data-cy']?: string };
export const DSTextField: React.FC<DSTextFieldProps> = props => <StyledTextField margin="dense" {...props} />;
DSTextField.displayName = 'DSTextField';
